"use client";

/**
 * `<TrackedLink>` — a `next/link` that fires a PostHog event on click, so
 * server components can instrument CTA clicks (which need a client handler)
 * without becoming client components themselves. Pairs with `<EventOnMount>`
 * (which instruments the VIEW): drop `<EventOnMount event="paywall_shown" .../>`
 * where the wall renders, and use `<TrackedLink event="upgrade_clicked" .../>`
 * for its CTA — that's the free→paid conversion funnel.
 *
 * The event fires fire-and-forget on click; navigation is never blocked (the
 * trackEvent wrapper no-ops when PostHog isn't consented/initialized).
 */

import Link from "next/link";
import type { ReactNode } from "react";
import { trackEvent } from "@/lib/posthog";

interface TrackedLinkProps {
  href: string;
  event: string;
  properties?: Record<string, unknown>;
  className?: string;
  children: ReactNode;
}

export function TrackedLink({ href, event, properties, className, children }: TrackedLinkProps) {
  return (
    <Link href={href} className={className} onClick={() => trackEvent(event, properties)}>
      {children}
    </Link>
  );
}
